'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  imageUrl: null,
  title: null,
  subtitle: null,
  templateButtons: null
}, 'Template');
module.exports = exports['default'];